"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_case__study__or__reports__or__white__paper__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "28644ca3-b568-4a62-8021-3ca26429fbc8",
    x1: 108.91,
    y1: 66.19,
    x2: 177.85,
    y2: 135.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f4b7ece4-2727-459a-b24d-6fc1e4667e0f",
    "data-name": "Reports_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12,
    ry: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12,
    ry: 12,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,160h-7.77l-.1-125L160,55.08,160,148A12,12,0,0,1,148,160Z",
    opacity: 0.2,
    fill: "url(#28644ca3-b568-4a62-8021-3ca26429fbc8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 104.25,
    height: 144,
    rx: 12,
    ry: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,107h61.17a1.42,1.42,0,0,1,1.41,1.41v1.17a1.42,1.42,0,0,1-1.41,1.41H59.91a1.42,1.42,0,0,1-1.41-1.41v-1.17A1.42,1.42,0,0,1,59.91,107Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,91h61.17a1.42,1.42,0,0,1,1.41,1.41v1.17A1.42,1.42,0,0,1,121.09,95H59.91a1.42,1.42,0,0,1-1.41-1.41V92.41A1.42,1.42,0,0,1,59.91,91Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,75h61.17a1.42,1.42,0,0,1,1.41,1.41v1.17A1.42,1.42,0,0,1,121.09,79H59.91a1.42,1.42,0,0,1-1.41-1.41V76.41A1.42,1.42,0,0,1,59.91,75Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.91,123h61.17a1.42,1.42,0,0,1,1.41,1.41v1.17a1.42,1.42,0,0,1-1.41,1.41H59.91a1.42,1.42,0,0,1-1.41-1.41v-1.17A1.42,1.42,0,0,1,59.91,123Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,158h-3.75v2H148a12,12,0,0,0,12-12v-2A12,12,0,0,1,148,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,174H52a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12h80.25a12,12,0,0,0,12-12v-2A12,12,0,0,1,132.25,174Z"
  })))), /*#__PURE__*/React.createElement("title", null, "case-study-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "f165ef19-d15a-4c37-8954-68e13c700dbb",
    "data-name": "Case_study_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "2def3bd9-4d3f-40bb-b0e4-70558c141787",
    "data-name": "Reports_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#f4b7ece4-2727-459a-b24d-6fc1e4667e0f"
  })));
}

var _default = ic_case__study__or__reports__or__white__paper__dark;
exports.default = _default;